import { BaseRouteService } from "./BaseRouteService";

export class InventoryService extends BaseRouteService {
    public async getInventory(): Promise<string[]> {
        return this.getJsonApi<string[]>("game/inventory");
    }
}
